import {mapActions, mapGetters, mapMutations} from 'vuex';

import statisticItem from '@/components/atoms/statistic-item/index.vue'
import chatComponent from '@/components/features/chat-component/index.vue'
import retakingHistory from '@/components/features/home-work-retaking-history/index.vue'

import homeWorkRate from '../../components/home-work-rate/index.vue'
import homeWorkRateComment from '../../components/home-work-rate-comment/index.vue'

import { seo } from '@/mixins/seo'

export default {
	name		: 'home-work-report',
	mixins		: [seo],
	components	: {
		statisticItem,
		chatComponent,
		homeWorkRate,
		homeWorkRateComment,
		retakingHistory
	},
	data() {
		return {
			isShowCorrectAnswer			: false,
			isShowCorrectAnswerLoading	: false
		}
	},
	created() {
		//console.log('home-work-report created');
		
		this.fetchItem({
			...this.$route.params,
		}).then(() => {
			this.setup();
			
			this.seo.title = this.currentItem.name + ' - ' + this.course.name;
			
			this.$emit('updateHead')
		})
	},
	mounted() {
		// after submit+navigation (and after a reload) land at the top of the page,
		// not stuck at the bottom where the submit button was
		this.$nextTick(() => {
			const app = document.querySelector('.app');
			if (app) app.scrollTop = 0;
			window.scrollTo(0, 0);
		});
	},
	computed	: {
		...mapGetters({
			reportResult	: 'coursesHomeWork/reportResult',
			currentItem		: 'coursesHomeWork/currentItem',
			isLoading		: 'coursesHomeWork/isLoading',
			isLoadingReport	: 'coursesHomeWork/isLoadingReport',
			course			: 'courses/currentItem',
			routeFromInfo	: 'coursesHomeWork/routeFromInfo',
		}),
		hasRate() {
			return !!(
				this.reportResult && 
				this.reportResult.homeWork.data.userRating.data.rating
				//this.reportResult.homeWork.data.type == "text"
			);
		},
		canBeRated() {
			return !!(
				this.reportResult && 
				['accepted', 'failed', 'expired'].includes(this.reportResult.status)
			)
		},
		hasPractic() {
			return this.reportResult.homeWork.data.type === 'text'
		},
		materialsList() {
			let concatMaterials = []
			
			if (!this.course) {
				return concatMaterials;
			}
			
			for (let module of this.course.modules.data) {
				concatMaterials = [...concatMaterials, ...module.materials.data]
			}
			
			return concatMaterials
		},
		nextActiveMaterial() {
			let currentSort = this.currentItem.sort,
				list = this.materialsList,
				activeMaterial = null;
			for (let item of list) {
				if (item.sort > currentSort) {
					let typeMaterial = item.material === 'lesson' ? 'userLesson' : 'userHomeWork';
					let status = item[typeMaterial].data.hasOwnProperty('id') ? item[typeMaterial].data.status : 'new';
					
					if (status !== 'failed' && status !== 'locked' && status !== 'expired') {
						activeMaterial = item;
						
						break;
					}
				}
			}
			
			return activeMaterial;
		}
	},
	methods		: {
		...mapActions({
			fetchData	: 'coursesHomeWork/GET_REPORT',
			fetchItem	: 'coursesHomeWork/GET_LIST_ITEM'
		}),
		...mapMutations({
			changeHeader		: 'coursesHomeWork/CHANGE_HEADER',
			setReportResult		: 'coursesHomeWork/SET_REPORT_RESULT',
			setItem				: 'coursesHomeWork/SET_ITEM',
			setQuestion			: 'coursesHomeWork/SET_CURRENT_QUESTION',
			changeRouteFromInfo	: 'coursesHomeWork/CHANGE_FROM_ROUTE_INFO',
		}),
		hasAnswer(question) {
			let answerStatus = false;
			
			question.question.data.answers.data.forEach(answer => {
				if (answer.userAnswer.data.id) {
					answerStatus = true;
				}
			});
			
			return answerStatus;
		},
		onNextMaterial() {
			let nextMaterial = this.nextActiveMaterial;
			
			if (!nextMaterial) return;
			
			const moduleSlug = this.course.modules.data.find(item => item.id === nextMaterial.moduleId).slug
			
			try {
				if (nextMaterial.material === 'lesson') {
					this.$router.push({
						name	: 'courses-lesson-detail',
						params	: {
							item		: this.$route.params.item,
							moduleSlug,
							lessonSlug	: nextMaterial.slug
						}
					})
				} else {
					this.$router.push({
						name	: 'home-work-rules',
						params	: {
							item		: this.$route.params.item,
							moduleSlug,
							testId		: nextMaterial.slug
						}
					})
				}
			} catch (e) {
				console.log('');
			}
		},
		setup() {
			this.fetchData({
				item		: this.$route.params.item,
				moduleSlug	: this.$route.params.moduleSlug,
				testId		: this.$route.params.testId
			}).catch(error => {
				if (error.response.status === 403) {
					// this.$toasted.error(error.response.data.error.message_key);
					try {
						this.$router.push({
							name	: 'home-work-check',
							params	: {
								...this.$route.params,
							}
						})
					} catch (e) {
						console.log(e);
					}
				}
			});
			
			this.changeHeader({
				show		: true,
				title		: this.$t('resultsOfHomework'),
				parentRoute	: {
					name		: 'courses-main',
					params		: {
						item		: this.$route.params.item
					}
				}
			})
		},
		navigateTo(route) {
			try {
				this.$router.push({
					name	: route,
					params	: {
						...this.$route.params,
					}
				})
			} catch (e) {
				console.log(e);
			}
		},
		showCorrectAnswer() {
			this.isShowCorrectAnswer = !this.isShowCorrectAnswer;
			this.isShowCorrectAnswerLoading = true;
			
			setTimeout(() => {
				this.isShowCorrectAnswerLoading = false;
			}, 600)
		},
		goBack() {
			this.$router.push({
				name	: this.routeFromInfo.name,
				params	: this.routeFromInfo.params
			});
		}
	},
	destroyed() {
		this.setReportResult(null)
		this.setItem(null)
		this.setQuestion(null)
		
		this.changeHeader({
			show			: false,
			title			: '',
			currentTime		: '',
			availableTime	: '',
			parentRoute		: ''
		})
	}
}
